import React from "react";
import { View } from "react-native";

import { useTheme, AHText, AHIcon } from "arkh";
import { TouchableOpacity } from "react-native-gesture-handler";
import { FormattedMessage } from "react-intl";
import { graphql, useFragment } from "react-relay";
import { TaskExecutionHeaderComponent_Task$key } from "./__generated__/TaskExecutionHeaderComponent_Task.graphql";
import { AHImageStackNew } from "./AHImageStack";

import {
  useLightboxControls,
} from "@/src/common/lightbox/LightboxProvider";

type TaskExecutionHeaderProps = {
  task: TaskExecutionHeaderComponent_Task$key;
  openInstructions: () => void;
};

function TaskExecutionHeaderCMP(props: TaskExecutionHeaderProps) {
  const theme = useTheme();

  const task = useFragment(
    graphql`
      fragment TaskExecutionHeaderComponent_Task on Task {
        id
        title
        instructions
        images {
          id
          sizes {
            height
            width
          }
          ...Image_image
          ...AHImageStackComponent_Images
        }
      }
    `,
    props.task
  );

  const { openLightbox } = useLightboxControls();

  return (
    <View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {task.images && task.images.length > 0 ? (
          <TouchableOpacity
            onPress={() => {
              openLightbox({
                images: task.images.map((image) => ({
                  image: {
                    type: "remote",
                    image: image,
                  },
                  mediaType: "image" as const,
                  dimensions: {
                    width: image.sizes?.[0]?.width ?? 1,
                    height: image.sizes?.[0]?.height ?? 1,
                  },
                })),
                index: 0,
              });
            }}
            style={{ paddingRight: 10 }}
          >
            <AHImageStackNew images={task.images} />
          </TouchableOpacity>
        ) : null}
        <AHText
          type="title-small"
          style={{ marginBottom: 2, flex: 1 }}
          adjustsFontSizeToFit
        >
          {task.title}
        </AHText>
      </View>
      {task.instructions ? (
        <AHText type="body" numberOfLines={3} spaceTop="small">
          {task.instructions}
        </AHText>
      ) : null}
      {task.instructions ? (
        <TouchableOpacity
          style={{
            flexDirection: "row",
            flex: 1,
            alignItems: "center",
            paddingTop: 10,
            paddingBottom: 10,
          }}
          hitSlop={{ top: 20, bottom: 0, right: 40, left: 40 }}
          onPress={props.openInstructions}
        >
          <AHText type="subtitle" style={{ color: theme.primary }}>
            <FormattedMessage
              defaultMessage="See Complete Instructions"
              description="TaskExecutionHeader: view instructions btn"
            />
          </AHText>
          <View style={{ marginLeft: 2 }}>
            <AHIcon type="arrow-up-right" forceSize={16} customColor={theme.primary} />
          </View>
        </TouchableOpacity>
      ) : null}
    </View>
  );
}

export const TaskExecutionHeader = TaskExecutionHeaderCMP;
